import { createSender } from 'shared/bi/bi-with-state-defaults';
import updateVodSettings from 'shared/redux/server/actions/vod-settings/update';
import { getBiIsFirst, getObjWithIsFirst } from 'shared/utils/bi/bi-first';

function send(state, biParams) {
  if (biParams.name) {
    createSender(state)(biParams.name, _.omit(biParams, 'name'));
  }
}

function runConfig(config, state, /* action */ { payload, meta } = {}) {
  let params = [state, payload, meta];

  if (config.isFirstKey) {
    const isFirst = getBiIsFirst(state.vodSettings, config.isFirstKey);
    params = [isFirst, ...params];
  }

  return config.handler(...params);
}

function processResult(state, dispatch, config, result) {
  send(state, result);

  if (config.isFirstKey) {
    dispatch(updateVodSettings(
      getObjWithIsFirst(config.isFirstKey)
    ));
  }
}

const returnEmptyParams = () => ({});

function runHandler(store, action, handler) {
  const state = store.getState();
  let config = null;

  // function or object with config
  if (_.isFunction(handler)) {
    config = { handler };
  } else if (_.isObject(handler)) {
    config = handler;
  } else if (_.isString(handler)) {
    config = {
      name: handler,
      handler: returnEmptyParams,
    };
  }

  // execute collected config
  if (config) {
    const result = runConfig(config, state, action);

    // if some result an bi event should be sent and with some actions from the config
    if (result) {
      processResult(state, store.dispatch, config, result);
    }
  }
}

export default actionHandlersStorage => store => next => action => {
  const type = _.get(action, 'type');
  runHandler(store, action, actionHandlersStorage[type]);
  return next(action);
};



// WEBPACK FOOTER //
// ./src/shared/bi/isolated/bi-middleware.js